export default {
  itemWrapper: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
  },
  defaultStyle: {
    fontSize: '16px',
    fontWeight: 400,
    color: (theme) => theme.palette.grays.gray700,
    width: '100%',
  },
  link: {
    textDecoration: 'none',
    fontWeight: 500,
    color: (theme) => theme.palette.blues.primaryBlue500,
  },
};
